<template>
    <tr @click="redirectToJourney(item.item)" :class="{'active-row': isActive}">
        <td>{{ dateFormat(item.item.startPoint.utc) }}</td>
        <td>{{ item.item.endPoint.utc !== null? dateFormat(item.item.endPoint.utc): '-' }}</td>
        <td>{{ item.item.startPoint.address && item.item.startPoint.address.label || 'Unknown' }}</td>
        <td>{{ item.item.endPoint.address && item.item.endPoint.address.label || 'Unknown' }}</td>
        <td :class="{'live': item.item.id === 'current'}">{{ item.item.id === 'current' ? 'LIVE' : distance(item.item.lengthMeters) }}</td>
    </tr>
</template>

<script>

import { formatDate, calculateSpeedOrDistanceUnit } from '@/helpers/Utils'
import { mapGetters } from 'vuex'

export default {
    name: 'JourneyTableRow',
    props: {
        item: {
            required: true
        },
        isActive: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            journey: null,
            routeStartAddress: '-',
            routeEndAddress: '-'
        }
    },
    computed: {
        ...mapGetters('authModule', [
            'getSpeedUnit'
        ])
    },
    methods: {
        redirectToJourney (journey) {
            this.$emit('redirect-journey', journey)
        },
        dateFormat (date) {
            return formatDate(date)
        },
        distance (value) {
            return 0 === this.getSpeedUnit ? `${Math.round(value / 1000)} km` : calculateSpeedOrDistanceUnit(Math.round(value / 1000), 'mi') + ' mi'
        }
    }
}
</script>

<style scoped lang="scss">
.active-row {
    background: rgba($success, 0.3)!important;
}

.live {
    color: $primary-default !important;
    font-weight: 900;
}
</style>
